export enum ErrorIcon {
  FUEL = 'fuel',
  CLEAN = 'clean',
  SERVICE = 'service',
}

export interface Error {
  alphaUiSymbol: string;
  alpha_40: string;
  alpha_41_42: string;
  alpha_60_65_70_75: string;
  description: string;
  id: string;
  logCode: string;
  notes: string;
  icons: ErrorIcon[];
}
